document.addEventListener('alpine:init', function () {
  Alpine.data('ctrProductBundle', function () {
    return {
      maxTiers: 4,
      selectedScents: {},
      purchaseOption: 'subscription',
      sellingPlanId: '5635145976',
      defaultSellingPlanId: '5635145976',
      preferDefaultSellingPlanId: true,
      sellingPlanName: '',
      sellingPlanFrequency: '',
      isStickyVisible: false,
      showScentScroll: false,
      isAdding: false,
      addButtonText: 'Add [amount] scent to cart',
      products: [],
      tierSaveLabels: ['Save $5.59', 'Save $19.98', 'Save $33.57', 'Save $47.96'],
      subscriptionTierPrices: [],
      oneTimeTierPrices: [],
      tierPriceDisplayVariant: 'per_load',
      tierDisplayNamespace: '',
      loadsPerUnit: 50,
      tierEachMultipliers: [1, 0.882, 0.847, 0.824],
      mainSwiper: null,
      thumbSwiper: null,
      stickyReveal: null,
      stickyEmptyAction: 'disable',
      stickyPromo: {
        title: 'Build your Bundle',
        titleEmpty: 'Start Building Your Bundle',
        promoEmpty: '<p>Add first item to unlock <span>FREE SHIPPING</span></p>',
        promoEmptyMobile: '<p>Add first item to unlock <span>FREE SHIPPING</span></p>',
        promoOnetime: '<p>SUBSCRIBE NOW to claim benefits</p>',
        promoMistOnly: '<p>You\'ve unlocked <span>FREE SHIPPING</span></p>',
        promoMistOnlyMobile: '<p>Subscription includes <span>FREE SHIPPING</span> only</p>',
        promoOneItem: '<p>You\'ve unlocked <span>FREE SHIPPING</span></p>',
        promoOneItemMobile: '<p>Add a Mozi to earn a <span>FREE gift worth $10</span></p>',
        promoTwoItems: '<p>You got your <span>FREE Silicone Measuring Cup</span> ($10 value)</p>',
        promoThreeItems: '<p>1 item away from <span>BIGGEST SAVINGS + FREEBIES!</span></p>',
        promoAllUnlocked: '<p>You\'ve unlocked <span>FREE SHIPPING</span></p>',
        promoAllUnlockedMobile: '<p>You\'ve unlocked <span>FREE SHIPPING + FREE GIFTS WORTH $10</span></p>',
      },

      init: function () {
        var configEl = this.$root.querySelector('[data-ref="bundleConfig"]');
        if (configEl) {
          try {
            var config = JSON.parse(configEl.textContent);
            this.maxTiers = config.maxTiers || 4;
            this.addButtonText = config.addButtonText || this.addButtonText;
            this.defaultSellingPlanId = String(config.defaultSellingPlanId || 5635145976);
            this.preferDefaultSellingPlanId = config.preferDefaultSellingPlanId !== false;
            this.sellingPlanName = config.sellingPlanName || '';
            this.sellingPlanFrequency = config.sellingPlanFrequency || '';
            this.tierSaveLabels = config.tierSaveLabels || this.tierSaveLabels;
            this.subscriptionTierPrices = config.subscriptionTierPrices || this.subscriptionTierPrices;
            this.oneTimeTierPrices = config.oneTimeTierPrices || this.oneTimeTierPrices;
            this.loadsPerUnit = config.loadsPerUnit || this.loadsPerUnit;
            this.tierDisplayNamespace = config.tierDisplayNamespace || '';
            this.stickyReveal = config.stickyReveal || null;
            this.stickyEmptyAction = config.stickyEmptyAction || 'disable';
            if (config.tierPriceDisplayVariant === 'per_load' || config.tierPriceDisplayVariant === 'each') {
              this.tierPriceDisplayVariant = config.tierPriceDisplayVariant;
            }
            this.products = config.products || [];
            this.sellingPlanId = String(this.resolveSellingPlanId(this.defaultSellingPlanId));
            if (config.stickyPromo) {
              // `self` is only declared after this try block, so bind the
              // component here rather than reaching for it.
              var component = this;
              Object.keys(config.stickyPromo).forEach(function (key) {
                if (config.stickyPromo[key]) {
                  component.stickyPromo[key] = config.stickyPromo[key];
                }
              });
            }
          } catch (error) {
            console.error('ctrProductBundle config parse failed', error);
          }
        }

        this.tierPriceDisplayVariant = this.resolveTierPriceDisplayVariant();

        var self = this;

        window.addEventListener(this.getTierDisplayEventName(), function (event) {
          var variant = event.detail;
          if (variant === 'per_load' || variant === 'each') {
            self.tierPriceDisplayVariant = variant;
          }
        });

        this.$nextTick(function () {
          self.initGallery();
          self.initSticky();
          self.initScentScroll();
          self.syncSellingPlanSelect();
        });
      },

      // A namespaced section reads its own global and event, so a sitewide test
      // driving window.ctrBundleTierDisplay cannot reach it. Blank namespace keeps
      // the original global and event names untouched.
      getTierDisplayGlobalName: function () {
        return 'ctrBundleTierDisplay' + (this.tierDisplayNamespace || '');
      },

      getTierDisplayEventName: function () {
        var namespace = this.tierDisplayNamespace;
        return namespace ? 'ctr:tier-display:' + namespace.toLowerCase() : 'ctr:tier-display';
      },

      resolveTierPriceDisplayVariant: function () {
        var params = new URLSearchParams(window.location.search);
        var urlVariant = params.get('tier_display');
        if (urlVariant === 'per_load' || urlVariant === 'each') {
          return urlVariant;
        }

        var globalVariant = window[this.getTierDisplayGlobalName()];
        if (globalVariant === 'per_load' || globalVariant === 'each') {
          return globalVariant;
        }

        if (this.tierPriceDisplayVariant === 'per_load' || this.tierPriceDisplayVariant === 'each') {
          return this.tierPriceDisplayVariant;
        }

        return 'per_load';
      },

      initScentScroll: function () {
        var self = this;
        this.updateScentScrollHint();

        if (this._scentScrollResizeHandler) {
          window.removeEventListener('resize', this._scentScrollResizeHandler);
        }

        this._scentScrollResizeHandler = function () {
          self.updateScentScrollHint();
        };

        window.addEventListener('resize', this._scentScrollResizeHandler, { passive: true });
      },

      updateScentScrollHint: function () {
        var list = this.$root.querySelector('[data-ref="scentList"]');
        if (!list) {
          this.showScentScroll = false;
          return;
        }

        var hasOverflow = list.scrollHeight > list.clientHeight + 1;
        var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 8;
        this.showScentScroll = hasOverflow && !atBottom;
      },

      initGallery: function () {
        if (typeof Swiper === 'undefined') return;

        var root = this.$root;
        var mainEl = root.querySelector('[data-ref="galleryMain"]');
        var thumbsEl = root.querySelector('[data-ref="galleryThumbs"]');
        if (!mainEl || mainEl.swiper) return;

        if (thumbsEl) {
          this.thumbSwiper = new Swiper(thumbsEl, {
            slidesPerView: 5,
            spaceBetween: 16,
            watchSlidesProgress: true,
            breakpoints: {
              0: { slidesPerView: 4, spaceBetween: 8 },
              990: { slidesPerView: 5, spaceBetween: 16 },
            },
          });
        }

        this.mainSwiper = new Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: root.querySelector('[data-ref="galleryNext"]'),
            prevEl: root.querySelector('[data-ref="galleryPrev"]'),
          },
          thumbs: this.thumbSwiper ? { swiper: this.thumbSwiper } : undefined,
        });
      },

      initSticky: function () {
        var self = this;
        var root = this.$root;
        var section = root.closest('.ctr-product-bundle-section') || root;
        var reveal = this.stickyReveal || {};
        // "after_bundle" waits for the buy box to scroll past, which never
        // happens when it is the last section on the page. "when_offscreen"
        // shows the bar whenever the buy box is out of view, held back by an
        // offset so it does not open over the hero.
        var revealWhenOffscreen = reveal.mode === 'when_offscreen';

        var onScroll = function () {
          var rect = section.getBoundingClientRect();

          if (!revealWhenOffscreen) {
            self.isStickyVisible = rect.bottom <= 0;
            return;
          }

          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          var offset = reveal.offset > 0 ? reveal.offset : viewportHeight;
          var isOffscreen = rect.bottom <= 0 || rect.top >= viewportHeight;
          self.isStickyVisible = isOffscreen && window.pageYOffset >= offset;
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll();
      },

      getTierLabel: function (tier) {
        if (tier === 1) return '1 Bottle';
        if (tier === 2) return '2 Bottles';
        if (tier === 3) return '3 Bottles';
        return '4+ Bottles';
      },

      getActiveTier: function () {
        var count = this.selectedCount();
        if (count <= 0) return 0;
        if (count >= this.maxTiers) return this.maxTiers;
        return count;
      },

      getPreviewTier: function () {
        return Math.max(this.getActiveTier(), 1);
      },

      isTierReached: function (tier) {
        var count = this.selectedCount();
        if (count <= 0) return false;

        var reachedTier = count >= this.maxTiers ? this.maxTiers : count;
        return tier <= reachedTier;
      },

      getTierProgressStyle: function () {
        var maxTiers = this.maxTiers || 1;
        if (maxTiers <= 1) {
          return { width: '0%' };
        }

        var activeTier = this.getActiveTier();
        if (activeTier <= 0) {
          return { width: '0%' };
        }

        var percent = ((activeTier - 1) / (maxTiers - 1)) * 100;
        return { width: percent + '%' };
      },

      isScentSelected: function (variantId) {
        return this.getScentQuantity(variantId) > 0;
      },

      getScentQuantity: function (variantId) {
        return this.selectedScents[String(variantId)] || 0;
      },

      selectedCount: function () {
        var self = this;
        return Object.keys(this.selectedScents).reduce(function (total, key) {
          return total + (self.selectedScents[key] || 0);
        }, 0);
      },

      getNonMistQty: function () {
        var self = this;
        return Object.keys(this.selectedScents).reduce(function (total, variantId) {
          var product = self.getProduct(variantId);
          if (!product || product.isMist) return total;
          return total + (self.selectedScents[variantId] || 0);
        }, 0);
      },

      getMistQty: function () {
        var self = this;
        return Object.keys(this.selectedScents).reduce(function (total, variantId) {
          var product = self.getProduct(variantId);
          if (!product || !product.isMist) return total;
          return total + (self.selectedScents[variantId] || 0);
        }, 0);
      },

      getStickyPromoState: function () {
        var nonMistQty = this.getNonMistQty();
        var mistQty = this.getMistQty();

        if (nonMistQty === 0 && mistQty === 0) {
          return 'empty';
        }

        if (this.purchaseOption !== 'subscription') {
          return 'onetime';
        }

        if (mistQty > 0 && nonMistQty === 0) {
          return 'mist_only';
        }

        if (nonMistQty >= this.maxTiers) {
          return 'all_unlocked';
        }

        if (nonMistQty === 3) {
          return 'three_items';
        }

        if (nonMistQty === 2) {
          return 'two_items';
        }

        return 'one_item';
      },

      getStickyTitle: function () {
        var state = this.getStickyPromoState();
        if (state === 'empty') {
          return this.stickyPromo.titleEmpty || this.stickyPromo.title;
        }

        return this.stickyPromo.title;
      },

      getStickyPromoText: function (isMobile) {
        var promo = this.stickyPromo;
        var state = this.getStickyPromoState();

        if (state === 'empty') {
          return isMobile ? promo.promoEmptyMobile || promo.promoEmpty : promo.promoEmpty;
        }

        if (state === 'onetime') {
          return promo.promoOnetime;
        }

        if (state === 'mist_only') {
          return isMobile ? promo.promoMistOnlyMobile || promo.promoMistOnly : promo.promoMistOnly;
        }

        if (state === 'one_item') {
          return isMobile ? promo.promoOneItemMobile || promo.promoOneItem : promo.promoOneItem;
        }

        if (state === 'two_items') {
          return promo.promoTwoItems;
        }

        if (state === 'three_items') {
          return promo.promoThreeItems;
        }

        return isMobile ? promo.promoAllUnlockedMobile || promo.promoAllUnlocked : promo.promoAllUnlocked;
      },

      incrementScent: function (variantId) {
        var key = String(variantId);
        var current = this.getScentQuantity(variantId);
        this.selectedScents = Object.assign({}, this.selectedScents, { [key]: current + 1 });
      },

      toggleScent: function (variantId) {
        this.incrementScent(variantId);
      },

      decrementScent: function (variantId) {
        var key = String(variantId);
        var current = this.getScentQuantity(variantId);
        if (current <= 0) return;
        if (current <= 1) {
          var next = Object.assign({}, this.selectedScents);
          delete next[key];
          this.selectedScents = next;
          return;
        }
        this.selectedScents = Object.assign({}, this.selectedScents, { [key]: current - 1 });
      },

      getProduct: function (variantId) {
        var id = parseInt(variantId, 10);
        return this.products.find(function (p) {
          return p.variantId === id;
        });
      },

      getFirstProduct: function () {
        return this.products.length ? this.products[0] : null;
      },

      getSellingPlans: function () {
        var firstProduct = this.getFirstProduct();
        if (!firstProduct || !firstProduct.sellingPlans) return [];
        return firstProduct.sellingPlans;
      },

      hasSellingPlans: function () {
        return this.getSellingPlans().length > 0;
      },

      resolveSellingPlanId: function (targetId) {
        var plans = this.getSellingPlans();
        var preferredId = String(targetId || this.defaultSellingPlanId || 5635145976);

        if (!plans.length) {
          return preferredId;
        }

        var preferredMatch = plans.find(function (plan) {
          return this.matchesSellingPlanId(plan.id, preferredId);
        }, this);

        if (preferredMatch) {
          return String(preferredMatch.id);
        }

        var defaultMatch = plans.find(function (plan) {
          return this.matchesSellingPlanId(plan.id, this.defaultSellingPlanId);
        }, this);

        return defaultMatch ? String(defaultMatch.id) : String(plans[0].id);
      },

      syncSellingPlanSelect: function () {
        var resolvedId = this.resolveSellingPlanId(this.defaultSellingPlanId);
        this.sellingPlanId = resolvedId;

        var select = this.$root.querySelector('[data-ref="sellingPlanSelect"]');
        if (!select) return;

        if (select.value !== resolvedId) {
          select.value = resolvedId;
        }
      },

      getBaseUnitPrice: function () {
        if (!this.products.length) return 0;
        return this.products[0].price;
      },

      getTierEachPrice: function (tier) {
        if (this.purchaseOption === 'subscription' && this.subscriptionTierPrices.length) {
          return this.getSubscriptionTierEachPrice(tier);
        }

        if (this.oneTimeTierPrices.length) {
          return this.getOneTimeTierEachPrice(tier);
        }

        var base = this.getBaseUnitPrice();
        var multiplier = this.tierEachMultipliers[tier - 1] || 1;
        return Math.round(base * multiplier);
      },

      isPerLoadDisplay: function () {
        return this.tierPriceDisplayVariant === 'per_load';
      },

      formatTierUnitPrice: function (tier) {
        var cents = this.getTierEachPrice(tier);

        if (this.isPerLoadDisplay()) {
          var divisor = this.loadsPerUnit || 50;
          return Math.round(cents / divisor) + '\u00A2';
        }

        return this.formatMoney(cents);
      },

      getTierUnitLabel: function () {
        return this.isPerLoadDisplay() ? 'per load' : 'each';
      },

      getSubscriptionTierEachPrice: function (tier) {
        var prices = this.subscriptionTierPrices;
        if (!prices.length) return 0;

        var index = Math.min(Math.max(tier - 1, 0), prices.length - 1);
        return prices[index] || 0;
      },

      getSubscriptionTierTotal: function (quantity) {
        if (quantity <= 0) return 0;

        var tier = quantity >= this.maxTiers ? this.maxTiers : quantity;
        return this.getSubscriptionTierEachPrice(tier) * quantity;
      },

      getOneTimeTierEachPrice: function (tier) {
        var prices = this.oneTimeTierPrices;
        if (!prices.length) return 0;

        var index = Math.min(Math.max(tier - 1, 0), prices.length - 1);
        return prices[index] || 0;
      },

      getOneTimeTierTotal: function (quantity) {
        if (quantity <= 0) return 0;

        var tier = quantity >= this.maxTiers ? this.maxTiers : quantity;
        return this.getOneTimeTierEachPrice(tier) * quantity;
      },

      getSelectedSubtotal: function () {
        var self = this;
        var total = 0;
        Object.keys(this.selectedScents).forEach(function (variantId) {
          var product = self.getProduct(variantId);
          var quantity = self.selectedScents[variantId] || 0;
          if (product) total += product.price * quantity;
        });
        return total;
      },

      getOneTimeBaseTotal: function () {
        return this.getSelectedSubtotal();
      },

      getOneTimeDiscountedTotal: function () {
        var totalQty = this.selectedCount();
        if (totalQty <= 0) return 0;

        if (this.oneTimeTierPrices.length) {
          return this.getOneTimeTierTotal(totalQty);
        }

        var basePrice = this.getSelectedSubtotal();
        var discountedPrice = basePrice;

        if (totalQty === 2) {
          discountedPrice = basePrice - 800;
        } else if (totalQty === 3) {
          discountedPrice = basePrice - 1920;
        } else if (totalQty >= 4) {
          discountedPrice = totalQty * 3199;
        }

        return Math.max(0, discountedPrice);
      },

      getSubscriptionBaseTotal: function () {
        return this.getSelectedSubtotal();
      },

      getSubscriptionDiscountedTotal: function () {
        var totalQty = this.selectedCount();
        if (totalQty <= 0) return 0;

        if (this.subscriptionTierPrices.length) {
          return this.getSubscriptionTierTotal(totalQty);
        }

        var basePrice = this.getSelectedSubtotal();
        var discountPercent = 0;

        if (totalQty === 1) discountPercent = 14;
        else if (totalQty === 2) discountPercent = 25;
        else if (totalQty === 3) discountPercent = 28;
        else if (totalQty >= 4) discountPercent = 30;

        var discountAmount = Math.round(basePrice * (discountPercent / 100));
        return basePrice - discountAmount;
      },

      shouldShowSubscriptionCompare: function () {
        return this.selectedCount() > 0;
      },

      shouldShowSubscriptionCurrent: function () {
        return this.selectedCount() > 0;
      },

      shouldShowOneTimeCompare: function () {
        return this.selectedCount() > 1;
      },

      shouldShowOneTimeCurrent: function () {
        return this.selectedCount() > 0;
      },

      matchesSellingPlanId: function (planId, targetId) {
        return String(planId) === String(targetId);
      },

      getProductSellingPlanId: function (product) {
        if (!product || !product.sellingPlans || !product.sellingPlans.length) return null;

        if (this.preferDefaultSellingPlanId && this.sellingPlanId) {
          var explicitMatch = product.sellingPlans.find(function (plan) {
            return this.matchesSellingPlanId(plan.id, this.sellingPlanId);
          }, this);
          if (explicitMatch) return explicitMatch.id;
          return this.sellingPlanId;
        }

        if (this.sellingPlanName) {
          var matchedByName = product.sellingPlans.find(function (plan) {
            return plan.name === this.sellingPlanName || plan.name.indexOf(this.sellingPlanName) !== -1;
          }, this);
          if (matchedByName) return matchedByName.id;
        }

        if (this.sellingPlanId) return this.sellingPlanId;
        return product.sellingPlans[0].id;
      },

      getSubscriptionPriceForProduct: function (product) {
        if (!product) return 0;

        var planId = this.getProductSellingPlanId(product);
        if (!planId || !product.sellingPlanAllocations || !product.sellingPlanAllocations.length) {
          return product.price;
        }

        var allocation = product.sellingPlanAllocations.find(function (item) {
          return this.matchesSellingPlanId(item.id, planId);
        }, this);

        return allocation ? allocation.price : product.price;
      },

      getDisplayTotal: function () {
        if (this.purchaseOption === 'subscription') {
          return this.getSubscriptionDiscountedTotal();
        }

        return this.getOneTimeDiscountedTotal();
      },

      formatMoney: function (cents) {
        var formatted;

        if (window.Shopify && Shopify.formatMoney) {
          formatted = Shopify.formatMoney(cents);
        } else {
          formatted = '$' + (cents / 100).toFixed(2);
        }

        if (cents % 100 === 0) {
          formatted = formatted.replace(/\.00$/, '').replace(/,00$/, '');
        }

        return formatted;
      },

      getButtonLabel: function () {
        return this.addButtonText.replace('[amount]', this.selectedCount());
      },

      canAddToCart: function () {
        return this.selectedCount() > 0 && !this.isAdding;
      },

      // The bar can be configured to appear before the buy box, where nothing is
      // selected yet and a disabled Add to cart is a dead end. In "scroll" mode
      // the button stays live and takes the visitor to the buy box instead.
      stickyScrollsWhenEmpty: function () {
        return this.stickyEmptyAction === 'scroll' && this.selectedCount() === 0;
      },

      canUseStickyAtc: function () {
        if (this.stickyScrollsWhenEmpty()) return !this.isAdding;
        return this.canAddToCart();
      },

      onStickyAtc: function () {
        if (this.stickyScrollsWhenEmpty()) {
          this.scrollToBundle();
          return;
        }
        this.addToCart();
      },

      scrollToBundle: function () {
        var target = this.$root;
        if (!target) return;

        // Clear any pinned header so the buy box does not land underneath it.
        var offset = 0;
        var header = document.querySelector('#shopify-section-header, header, .header');
        if (header) {
          var headerPosition = window.getComputedStyle(header).position;
          if (headerPosition === 'fixed' || headerPosition === 'sticky') {
            offset = header.getBoundingClientRect().height;
          }
        }

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
        window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      },

      setPurchaseOption: function (option) {
        this.purchaseOption = option;
      },

      resetState: function () {
        this.selectedScents = {};
        this.updateScentScrollHint();
      },

      getMatchedSellingPlanId: function (product) {
        return this.getProductSellingPlanId(product);
      },

      addToCart: function () {
        if (!this.canAddToCart()) return;

        var self = this;
        this.isAdding = true;
        var variantIds = Object.keys(this.selectedScents);
        var items = [];

        variantIds.forEach(function (variantId) {
          var product = self.getProduct(variantId);
          if (!product) return;

          var quantity = self.selectedScents[variantId] || 1;
          if (quantity <= 0) return;

          var item = {
            id: parseInt(variantId, 10),
            quantity: quantity,
            properties: {},
          };

          if (self.purchaseOption === 'subscription' && product.hasSubscription) {
            var planId = self.getMatchedSellingPlanId(product);
            if (planId) {
              item.selling_plan = parseInt(planId, 10);
            }
          } else {
            item.properties['Purchase Type'] = 'One Time';
          }

          if (!Object.keys(item.properties).length) {
            delete item.properties;
          }

          items.push(item);
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) {
                throw new Error(err.description || 'Unknown cart error');
              });
            }
            return response.json();
          })
          .then(function () {
            self.resetState();

            if (window.openSidecart) {
              window.openSidecart();
              if (window.fetchCart) window.fetchCart();
            }
          })
          .catch(function (err) {
            alert(err.message || err);
          })
          .finally(function () {
            self.isAdding = false;
          });
      },
    };
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ctr-product-bundle[data-section-id]');
    if (!section || typeof Swiper === 'undefined') return;
    var mainEl = section.querySelector('[data-ref="galleryMain"]');
    if (mainEl && mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }
    var thumbsEl = section.querySelector('[data-ref="galleryThumbs"]');
    if (thumbsEl && thumbsEl.swiper) {
      thumbsEl.swiper.destroy(true, true);
    }
  });
}
